// Anmeldeprobe (Schlusslauf 3, 10.10.2026): die Fehlermeldung der Anmeldeseite trägt den Titel „Anmeldung nicht möglich.“.
// Der Satz des Servers beginnt bei falschem Passwort mit denselben Worten (backend operator/auth.ts LOGIN_FAILED); unter
// dem Titel steht er deshalb ohne diesen Anfang. Reine Funktion, geprüft in frontend/tests/anmelde-meldung.test.mjs.
export const ANMELDUNG_NICHT_MOEGLICH = 'Anmeldung nicht möglich.';

export function meldungOhneTitel(satz: string, titel: string = ANMELDUNG_NICHT_MOEGLICH): string {
  const rest = satz.startsWith(titel) ? satz.slice(titel.length).trim() : satz;
  return rest || satz;
}

// PF-LG-nach-1 (Bennys HTML-Entwurf vom 20.10.2026, :242-283): Die Anmeldung prüft vor dem Absenden selbst und zeigt den Satz unter
// dem Feld statt der Blase des Browsers. Ob die Adresse gültig ist, sagt das Feld (type="email", validity.valid), wie im Entwurf.
export const ANMELDE_FELDER = {
  emailLeer: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
  emailUngueltig: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  passwortLeer: 'Bitte geben Sie Ihr Passwort ein.',
} as const;

export function pruefeAnmeldeFelder(email: string, emailGueltig: boolean, passwort: string): { email: string; passwort: string } {
  return {
    email: !email.trim() ? ANMELDE_FELDER.emailLeer : !emailGueltig ? ANMELDE_FELDER.emailUngueltig : '',
    passwort: passwort ? '' : ANMELDE_FELDER.passwortLeer,
  };
}
